import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

export type Lang = 'en' | 'ta';

/**
 * Read/write the interface language through the URL query param (`?lang=…`).
 *
 * Deliberately NOT persisted in localStorage — the spec is explicit that
 * the choice should be shareable via URL, not sticky across visits.
 */
export function useLang(): [Lang, (next: Lang) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('lang');
  const lang: Lang = raw === 'ta' ? 'ta' : 'en';
  const setLang = useCallback(
    (next: Lang) => {
      const p = new URLSearchParams(params);
      if (next === 'en') p.delete('lang');
      else p.set('lang', next);
      setParams(p, { replace: true });
    },
    [params, setParams]
  );
  return [lang, setLang];
}
